/* @flow */
/**
 * Created by Ondra on 20.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import {closeMenu, changeMenuPanel} from '../../common/menu/actions';
import {logout} from '../../common/login/actions';
import {openMessage} from '../../common/components/messages/actions';
import {fullLoadingHide} from '../../common/components/loadings/actions';
import {fetchIsBarReportOpen2, openCloseReportPanel, isBillOutOfReport} from '../../common/report/actions';
import {hasTablesProduct} from '../../common/lib/util';
import MenuList from './MenuList';
import Storno from './Storno';
import Shifts from './report/shifts/Shifts';
import Habitues from './credit/habitues/Habitues';
import HabitueDetail from './credit/debtDetail/HabitueDetail';
import Settings from './settings/Settings';
import Favourite from './favourite/Favourite';
import Transactions from './report/transactions/Transactions';
import CalculateCashboxes from './report/cashboxes/CalculateCashboxes';
import {onlineCheck} from '../../common/categories/actions';
import LogoutButton from '../components/buttons/LogoutButton';

class Menu extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        openCloseReportPanel: React.PropTypes.func,
        fullLoadingHide: React.PropTypes.func,
        isBillOutOfReport: React.PropTypes.func,
        onlineCheck: React.PropTypes.func,
        changeMenuPanel: React.PropTypes.func,
        fetchIsBarReportOpen2: React.PropTypes.func,
        openMessage: React.PropTypes.func,
        closeMenu: React.PropTypes.func,
        logout: React.PropTypes.func,
        bar: React.PropTypes.object,
        waitingOrders: React.PropTypes.object,
        menuTypes: React.PropTypes.object,
        homepage: React.PropTypes.object,
        defaultTablesVisible: React.PropTypes.bool,
        menuType: React.PropTypes.string,
        deviceId: React.PropTypes.number
    };

    constructor(props) {
        super(props);

        this.logout = this.logout.bind(this);
        this.showPanel = this.showPanel.bind(this);
        this.changeMenu = this.changeMenu.bind(this);
    }

    logout() {
        const {
            logout, closeMenu, tables, openMessage, fetchIsBarReportOpen2, bar, openCloseReportPanel, deviceId,
            waitingOrders, isBillOutOfReport, fullLoadingHide, msg
        } = this.props;

        closeMenu();
        if (!hasTablesProduct(tables)) {
            fetchIsBarReportOpen2(bar.get('id')).payload.promise
                .then((res) => {
                    if (!res.data) {
                        isBillOutOfReport(bar.get('id'))
                            .payload.promise
                            .then((res) => {
                                if (!!res.data) {
                                    openMessage(msg.menu.message.reportClosed1 + ' ' + res.data + ' ' + msg.menu.message.reportClosed2);
                                }
                                logout(deviceId);
                            })
                            .catch(() => {
                                logout(deviceId);
                            });
                    } else {
                        fullLoadingHide();
                        openCloseReportPanel();
                    }
                })
                .catch(() => {
                    fullLoadingHide();
                    if (!!waitingOrders && waitingOrders.size > 0) {
                        openMessage(msg.menu.message.deviceOffline, msg.menu.message.unableCloseReport + ' ' + msg.menu.message.notSentBills + ': ' + waitingOrders.size + '. ' + msg.menu.message.billSendLater);
                    } else {
                        openMessage(msg.menu.message.deviceOffline, msg.menu.message.unableCloseReport);
                    }
                    logout(deviceId);
                });
        } else {
            openMessage(msg.menu.message.tablesNotPayed);
        }
    }

    showPanel(menuType, homepage) {
        const {menuTypes} = this.props;

        switch (menuType) {
            case menuTypes.CHANGE_OFFER: {
                return <Settings />;
            }
            case menuTypes.SETTINGS: {
                return <Settings />;
            }
            case menuTypes.STORNO: {
                return <Storno homepage={homepage}/>
            }
            case menuTypes.FAVOURITE: {
                return <Favourite homepage={homepage}/>
            }
            case menuTypes.SHIFTS: {
                return <Shifts />;
            }
            case menuTypes.TRANSACTIONS: {
                return <Transactions />;
            }
            case menuTypes.CREDITS: {
                return <Habitues />;
            }
            case menuTypes.CREDIT_DETAIL: {
                return <HabitueDetail />;
            }
            case menuTypes.CALCULATE_CASHBOXES: {
                return <CalculateCashboxes />;
            }
        }
        return <MenuList homepage={homepage}/>;
    }

    changeMenu() {
        const {changeMenuPanel, closeMenu, menuType} = this.props;
        if (menuType !== null) {
            changeMenuPanel(null);
        } else {
            closeMenu();
        }
    }

    componentWillMount() {
        const {onlineCheck} = this.props;
        onlineCheck();
    }

    render() {
        const {
            closeMenu, homepage, waitingOrders, menuType, defaultTablesVisible, msg
        } = this.props;

        return (
            <div id="menu" className="pageMenu">
                <div className="pageMenu-panel menu-panel">
                    {this.showPanel(menuType, homepage)}
                </div>
                <div className="pageMenu-controls controls">
                  <div className="pageMenu-controls-key">
                    <div className="boxBtn text-l">
                        {!!waitingOrders && waitingOrders.size > 0 &&
                        <div className="boxBtn-inner">
                            <span>
                                {msg.menu.waitingOrders} {waitingOrders.size}
                            </span>
                        </div>
                        }
                    </div>
                  </div>
                  <div className="pageMenu-controls-key">
                    <div className="boxBtn text-l color-greenLight">
                        <div className="boxBtn-inner" onClick={() => this.changeMenu()}>
                          <svg className={`shape shape-bars`}>
                            <use xlinkHref={`#shape-bars`}></use>
                          </svg>
                        </div>
                    </div>
                  </div>
                  <div className="pageMenu-controls-key view-half">
                    <div className="boxBtn text-l color-green">
                        <div className="boxBtn-inner" onClick={() => closeMenu()}>
                            <span>{defaultTablesVisible ? msg.menu.toTables : msg.menu.toCashbox}</span>
                        </div>
                    </div>
                  </div>
                  <div className="pageMenu-controls-key view-half">
                    <div className="boxBtn text-l color-red" onClick={() => this.logout()}>
                        <LogoutButton/>
                    </div>
                  </div>
                </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    tables: state.categories.get('tables'),
    defaultTablesVisible: state.tables.get('defaultTablesVisible'),
    bar: state.bars.get('bar'),
    waitingOrders: state.categories.get('waitingOrders'),
    menuType: state.menu.get('menuType'),
    menuTypes: state.menu.get('menuTypes'),
    deviceId: state.device.get('id')
}), {
    logout, closeMenu, onlineCheck, openMessage, fetchIsBarReportOpen2, openCloseReportPanel, changeMenuPanel,
    isBillOutOfReport, fullLoadingHide
})(Menu);



// WEBPACK FOOTER //
// ./src/browser/menu/Menu.js